
function Loader2() {
  return (
    <div className="w-auto h-auto flex justify-center items-center">
      <div className="flex w-4 h-4 rounded-full animate-spin border-[2px] border-solid border-black  border-b-transparent"></div>
    </div>
  );
}
export default Loader2;
